import React, { useEffect, useState } from "react";
import { Col, Row, Spin, DatePicker, Typography, Divider, Tooltip, Button } from "antd";
import { CSVLink } from "react-csv";
import { DASHBOARD, HEADERS_FOR_FUNCTION_DOWNLOADS, HEADERS_FOR_USER_DOWNLOADS, HEADERS_FOR_SITE_DOWNLOADS, HEADERS_FOR_RECENT_ACTIVITY, HEADERS_FOR_RECENT_DOWNLOAD_REASONS, HEADERS_FOR_CAMPAIGN_DOWNLOADS, MetaTitle } from "../../../common/constants/constants";
import DownloadsbyPosition from "./downloadsbyPosition";
import Downloadsbycampaign from "./downloadsbycampaign";
import DownloadsByFuntion from "./downloadsByFunction";
import ActiveUser from "./activeusers";
import DownloadReasons from "./downloadreasons";
import Mostdownloaded from "./mostdownloaded";
import Downloadsbysite from "./downloadsbysite-wday";
import TopPositions from "./topPositions";
import { DownloadOutlined, GlobalOutlined, ContactsOutlined, CalendarOutlined, SnippetsOutlined, LoadingOutlined, LoginOutlined, AlignLeftOutlined, InfoCircleOutlined, CloudDownloadOutlined } from '@ant-design/icons';
import { service } from "../../../services";
import './dashboard.scss'
import Meta from "../../../Meta";
import moment from 'moment';
const { Text, Link } = Typography;

const Dashboard = () => {
  
  let today = new Date();
  let todayDate = today.getDate();
  let preweek = new Date(today.getFullYear(), today.getMonth(), today.getDate() - 7);
  let date = preweek.getDate();
  let month = preweek.getMonth() + 1;
  let year = preweek.getFullYear();
  let startDate = (year + "-" + month + "-" + date);
  let endMonth = today.getMonth()+1;
  let endDate=(today.getFullYear()+"-"+endMonth+"-"+todayDate);
  const { RangePicker } = DatePicker;
  const dateFormat = 'YYYY-MM-DD';
  const [timeDuration, setTimeDuration] = useState({ startDate: startDate, endDate: endDate });
  const [loading, setLoading] = useState(false);
  const [totalDownloads, setTotalDownloads] = useState([]);
  const [totalLogins, setTotalLogins] = useState([]);
  const [reasonData, setReasonData] = useState([]);
  const [totalCampaign, setTotalCampaign] = useState([]);
  const [totalPositions, setTotalPositions] = useState([]);
  const [totalTopDownloads, setTotalTopDownloads] = useState([]);
  const [downlodsBySite, setDownlodsBySite] = useState([]);
  const [recentActivity, setRecentActivity] = useState([]);
  const [recentDownloadTeasons, setRecentDownloadTeasons] = useState([]);
  const antIcon = (
    <LoadingOutlined
      style={{
        fontSize: 24,
      }}
      spin
    />
  );

  useEffect(() => {
    const getTotalDownloads = async (value) => {
      setLoading(true);
      let response = await service.getTotalDownloads(value);
      if (response.success) {
        setTotalDownloads(response?.data['accessLogsData'][0]);
        setTotalLogins(response?.data['loginLogsData'][0]?.total_logins);
        setReasonData(response?.data['reasonData']);
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getTotalDownloads(timeDuration)
  }, [timeDuration])


  useEffect(() => {
    const getTotalCampaign = async (value) => {
      setLoading(true);
      let response = await service.getTotalCampaign(value);
      if (response.success) {
        setTotalCampaign(response.data)
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getTotalCampaign(timeDuration)
  }, [timeDuration])


  useEffect(() => {
    const getTotalPosition = async (value) => {
      setLoading(true);
      let response = await service.getTotalPosition(value);
      if (response.success) {
        setTotalPositions(response.data)
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getTotalPosition(timeDuration)
  }, [timeDuration])


  useEffect(() => {
    const getTopDownloads = async (value) => {
      setLoading(true);
      let response = await service.getTopDownloads(value);
      if (response.success) {
        setTotalTopDownloads(response.data)
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getTopDownloads(timeDuration)
  }, [timeDuration])


  useEffect(() => {
    const getDownlodsBySite = async (value) => {
      setLoading(true);
      let response = await service.getDownlodsBySite(value);
      if (response.success) {
        setDownlodsBySite(response.data)
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getDownlodsBySite(timeDuration)
  }, [timeDuration])


  useEffect(() => {
    const getRecentActivity = async (value) => {
      setLoading(true);
      let response = await service.getRecentActivity(value);
      if (response.success) {
        setRecentActivity(response.data)
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getRecentActivity(timeDuration)
  }, [timeDuration])

  useEffect(() => {
    const getRecentDownloadReasons = async (value) => {
      setLoading(true);
      let response = await service.getRecentDownloadReasons(value);
      if (response.success) {
        setRecentDownloadTeasons(response.data)
        setLoading(false);
      } else {
        console.log("error", response.message)
      }
    }
    getRecentDownloadReasons(timeDuration)
  }, [timeDuration])

  const onChange = (value, dateString) => {
    setTimeDuration({
      startDate: dateString[0],
      endDate: dateString[1]
    })
  };

  const exportToCsv = (key) => {
    const payload = {
      startDate: timeDuration.startDate,
      endDate: timeDuration.endDate,
      key: key,
    };
  };

  const DashboardCard = (props) => {
    const { title, value, icon } = props
    return (
      <div className="dashboard-card">
        <div className="left-card">
          <p>{icon} {title}</p>
          <h3>{value}</h3>
        </div>
      </div>
    )
  }

  const DashboardReasonCountCard = (props) => {
    const { title, reasonGivenCount, reasonNotGivenCount, reasonGivenPercent, reasonNotGivenPercent, icon } = props
    return (
      <div className="dashboard-card">
        <div className="left-card left-card-reason">
          <p>
            <span className="reason-card-span">
              {icon} {title} 
            </span>
            <Tooltip placement="leftBottom" color="#6E81FF" title="Reason provided by Employee while downloading Snapshot file!">
              <InfoCircleOutlined
                style={{ fontSize: '16px', marginLeft:'5px' }}
              />
            </Tooltip>
          </p>
          <div className="left-card-reason-div">
            <div className="dashboard-reason-count-div">
              <span>Provided : </span><h3>&nbsp;{reasonGivenCount} <Text type="success">({reasonGivenPercent}%)</Text></h3>
            </div>
            <Divider type="vertical" style={{ height: "100%", color:'#000' }} />
            <div className="dashboard-reason-count-div">
              <span>Not Provided : </span><h3>&nbsp;{reasonNotGivenCount} <Text type="warning">({reasonNotGivenPercent}%)</Text></h3>
            </div>
          </div>
        </div>
      </div>
    )
  }

  const ExportToCsvButton = (props) => {
    
    let { data, exportFile, headers, file } = props;
    let fileName = file + "_" + timeDuration.startDate.replace(/-/g, "") + "_" + timeDuration.endDate.replace(/-/g, "");

    // trim data for top 10 functions
    data = exportFile == DASHBOARD.TOP_FUNTIONS ? data.slice(0, 10) : data;
    
    return (
      <Tooltip placement="leftBottom" color="#737373" title="Export to CSV">
        <CSVLink data={data} headers={headers} filename={fileName+".csv"}>
          <Button type="primary" className="graph-card-btn" shape="circle" icon={<DownloadOutlined />} size="small" />
        </CSVLink>
      </Tooltip>
    )
  }

  const headersForPositionDownloads = [
    { label: "First Name", key: "position" },
    { label: "Last Name", key: "downloads" }
  ];

  const { total_campaign, total_downloads, total_positions, total_site } = totalDownloads;
  const reasonGivenCount = reasonData[0]?.count;
  const reasonNotGivenCount = reasonData[1]?.count;
  const reasonTotalCount = parseInt(reasonGivenCount) + parseInt(reasonNotGivenCount);
  const reasonGivenPercent = Math.floor((reasonGivenCount/reasonTotalCount * 100));
  const reasonNotGivenPercent = (100-reasonGivenPercent);

  return (
    <>
    <Meta name={MetaTitle.Dashboard}/>
    <div className="dashboard-wrapper">
      <Row style={{ marginBottom: "10px" }}>
        <Col span={24}>
          <div className="date-picker">
            <h4>Date Range</h4>
            <RangePicker
              defaultValue={[moment(timeDuration.startDate, dateFormat), moment(timeDuration.endDate, dateFormat)]}
              format={dateFormat}
              onChange={onChange}
            />
          </div>
        </Col>
      </Row>
      <Spin spinning={loading} indicator={antIcon}>
        <Row gutter={[10, 10]} >
          <Col span={7}>
            <DashboardCard title="Total Logins" value={totalLogins} icon={<LoginOutlined />} />
          </Col>
          <Col span={7}>
            <DashboardCard title="Total Downloads" value={total_downloads} icon={<DownloadOutlined />} />
          </Col>
          <Col span={10}>
            <DashboardReasonCountCard title="Reasons" reasonGivenCount={reasonGivenCount} reasonNotGivenCount={reasonNotGivenCount} reasonGivenPercent={reasonGivenPercent} reasonNotGivenPercent={reasonNotGivenPercent} icon={<AlignLeftOutlined />} />
          </Col>

          {/* <Col span={6}>
            <DashboardCard title="Sites" value={total_site} icon={<GlobalOutlined />} />
          </Col>
          <Col span={6}>
            <DashboardCard title="Campaigns" value={total_campaign} icon={<SnippetsOutlined />} />
          </Col> */}
          {/* <Col span={6}>
            <DashboardCard title="Positions" value={total_positions} icon={<ContactsOutlined />} />
          </Col> */}
          
          <Col span={16}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Downloads by Function</h1>
                  <ExportToCsvButton data={totalPositions} exportFile={DASHBOARD.DOWNLOADS_BY_FUNCTION} headers={HEADERS_FOR_FUNCTION_DOWNLOADS} file="DOWNLOADS_BY_FUNCTION"/>
              </div>
              <DownloadsByFuntion functionData={totalPositions} />
            </div>
          </Col>
          <Col span={8}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Top 10 Functions</h1>
                  <ExportToCsvButton data={totalPositions.slice(0, 10)} exportFile={DASHBOARD.TOP_FUNTIONS} headers={HEADERS_FOR_FUNCTION_DOWNLOADS} file="TOP_FUNTIONS"/>
              </div>
              <TopPositions totalPositions={totalPositions} />
            </div>
          </Col>

          <Col span={14}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Top Downloads by User</h1>
                  <ExportToCsvButton data={totalTopDownloads} exportFile={DASHBOARD.DOWNLOADS_BY_USER} headers={HEADERS_FOR_USER_DOWNLOADS} file="DOWNLOADS_BY_USER"/>
              </div>
              <Mostdownloaded totalTopDownload={totalTopDownloads} />
            </div>
          </Col>
          <Col span={10}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Downloads by Site</h1>
                  <ExportToCsvButton data={downlodsBySite} exportFile={DASHBOARD.DOWNLOADS_BY_SITE} headers={HEADERS_FOR_SITE_DOWNLOADS} file="DOWNLOADS_BY_SITE"/>
              </div>
              <Downloadsbysite downlodsBySite={downlodsBySite} />
            </div>
          </Col>

          {/* <Col span={10}><div className="graph-card">
            <h1>Downloads by Position</h1>
            <DownloadsbyPosition positionData={totalPositions} /></div>
          </Col> */}

          <Col span={6}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Recent Activity</h1>
                  <ExportToCsvButton data={recentActivity} exportFile={DASHBOARD.RECENT_ACTIVITY} headers={HEADERS_FOR_RECENT_ACTIVITY} file="RECENT_ACTIVITY"/>
              </div>
              <ActiveUser recentActivity={recentActivity} />
            </div>
          </Col>
          <Col span={6}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Recent Download Reasons</h1>
                  <ExportToCsvButton data={recentDownloadTeasons} exportFile={DASHBOARD.RECENT_DOWNLOAD_REASONS} headers={HEADERS_FOR_RECENT_DOWNLOAD_REASONS} file="RECENT_DOWNLOAD_REASONS"/>
              </div>
              <DownloadReasons recentDownloadTeasons={recentDownloadTeasons} />
            </div>
          </Col>
          <Col span={12}>
            <div className="graph-card">
              <div className="card-heading">
                <h1 className="card-title-h1">Downloads by Campaign</h1>
                  <ExportToCsvButton data={totalCampaign} exportFile={DASHBOARD.DOWNLOADS_BY_CAMPAIGN} headers={HEADERS_FOR_CAMPAIGN_DOWNLOADS} file="DOWNLOADS_BY_CAMPAIGN"/>
              </div>
              <Downloadsbycampaign campaignData={totalCampaign} />
            </div>
          </Col>
        </Row>
      </Spin>
    </div>
    </>
  );
};

export default Dashboard;
